/*
  Sainté — Size Finder, UI-laget
  ==================================================================
  Beregningen ligger i sainte-size-engine.js og kender ikke til DOM'en.
  Denne fil stiller spørgsmålene, viser svaret og sætter varianten.

  Data kommer fra snippet'et sainte-size-finder.liquid via
  window.SainteSizeFinderData — størrelsesguide, varianter og
  billedstier. Ingen stier er skrevet ind i koden her; Shopify skal
  danne dem med asset_url, og de samles derfor ét sted i Liquid.
*/
(function () {
  'use strict';

  var SF = {};

  /* Tekster fra locales (sainte.sf.*). sainte-size-finder.liquid skriver dem
     ud som window.SAINTE_SF_I18N før filerne indlæses. Den danske tekst står
     som standard her, så intet ændrer sig hvis objektet mangler (okt 2026). */
  var I18N = window.SAINTE_SF_I18N || {};
  function L(k, d, v) {
    var s = I18N[k] || d;
    return v ? String(s).replace(/%(\w+)%/g, function (m, x) { return v[x] != null ? v[x] : m; }) : s;
  }

  /* ------------------------------------------------------------------
     SPØRGSMÅLSSÆT
     Nøglen er varens kategori. V1 dækker tops. Et nyt sæt tilføjes her
     uden at røre hverken motoren eller resten af UI'et.
     ------------------------------------------------------------------ */
  var QUESTION_SETS = {
    tops: [
      { id: 'gender', type: 'choice', heading: L('q_gender', 'Hvilken type størrelse foretrækker du?'),
        options: [{ value: 'men', label: L('gender_men', 'Mænd') }, { value: 'women', label: L('gender_women', 'Kvinders') }] },

      { id: 'usualSize', type: 'sizes',
        heading: L('q_usual', 'Hvilken størrelse har du flest af i din garderobe?') },

      { id: 'consistency', type: 'choice', heading: L('q_consistency', 'Bruger du altid denne størrelse?'),
        options: [
          { value: 'smaller', label: L('cons_smaller', 'Nej, jeg bruger nogle gange en mindre størrelse') },
          { value: 'always', label: L('cons_always', 'Ja, jeg bruger altid denne størrelse') },
          { value: 'larger', label: L('cons_larger', 'Nej, jeg bruger nogle gange en større størrelse') }
        ] },

      { id: 'belly', type: 'cards', heading: L('q_belly', 'Beskriv formen på din mave'), asset: 'belly',
        options: [
          { value: 'flat', label: L('belly_flat', 'Flad') },
          { value: 'average', label: L('opt_average', 'Gennemsnitlig') },
          { value: 'round', label: L('belly_round', 'Rund') }
        ] },

      /* Spørgsmålet er ikke det samme for de to sæt illustrationer: mændenes
         tegning viser bryst og skuldre, kvindernes viser barmen. Vi spørger
         derfor om det, billedet faktisk viser. */
      { id: 'upperBody', type: 'cards', asset: 'upper',
        heading: { men: L('q_upper_men', 'Hvordan vil du beskrive din overkrop?'),
                   women: L('q_upper_women', 'Beskriv størrelsen på din barm') },
        options: [
          { value: 'narrow', label: L('upper_narrow', 'Smal') },
          { value: 'average', label: L('opt_average', 'Gennemsnitlig') },
          { value: 'broad', label: L('upper_broad', 'Bred') }
        ] },

      { id: 'height', type: 'height', heading: L('q_height', 'Hvor høj er du?') },

      { id: 'fitPreference', type: 'choice', heading: L('q_fit', 'Hvilken pasform foretrækker du?'),
        options: [
          { value: 'tighter', label: L('fit_tighter', 'Strammere') },
          { value: 'normal', label: L('fit_normal', 'Normal') },
          { value: 'looser', label: L('fit_looser', 'Løsere') }
        ] }
    ]
  };

  var HEIGHT = { men: { min: 150, max: 210, start: 180 }, women: { min: 140, max: 200, start: 168 } };

  var EYEBROW = L('eyebrow', 'Lad os finde din perfekte størrelse');

  var ICON_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  /* ------------------------------------------------------------------
     Analytics. Der er ingen platform koblet på endnu, så hændelserne
     sendes som CustomEvents og skubbes i dataLayer hvis den findes.
     Når vi vælger værktøj, lyttes der ét sted i stedet for at rette her.
     ------------------------------------------------------------------ */
  function track(name, detail) {
    detail = detail || {};
    try {
      document.dispatchEvent(new CustomEvent('sainte:size-finder', {
        detail: Object.assign({ event: name }, detail)
      }));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'sainte_' + name }, detail));
    } catch (e) { /* analytics må aldrig vælte flowet */ }
  }

  /* ------------------------------------------------------------------ */

  function State(data) {
    this.data = data;
    this.set = QUESTION_SETS[data.guide.category] || QUESTION_SETS.tops;
    this.answers = {};
    this.index = 0;
    this.result = null;
  }
  State.prototype.current = function () { return this.set[this.index]; };
  State.prototype.total = function () { return this.set.length; };
  State.prototype.reset = function () { this.answers = {}; this.index = 0; this.result = null; };

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Billedstier kommer fra Liquid. Nøglen er "<køn>-<gruppe>-<værdi>". */
  function assetFor(data, gender, group, value) {
    return data.assets[gender + '-' + group + '-' + value] || null;
  }

  function SizeFinder(root, data) {
    this.data = data;
    this.state = new State(data);
    this.dlg = root;
    this.bar = root.querySelector('.sainte-sf__bar');
    this.back = root.querySelector('[data-sf-back]');
    this.body = root.querySelector('.sainte-sf__body');
    this.foot = root.querySelector('.sainte-sf__foot');
    this.bind();
  }

  SizeFinder.prototype.bind = function () {
    var self = this;
    this.back.addEventListener('click', function () { self.prev(); });
    this.dlg.querySelector('[data-sf-close]').addEventListener('click', function () { self.close(); });
    /* ESC kommer som cancel fra <dialog>; vi tager den for at rydde op. */
    this.dlg.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
  };

  /* Knappen står inde i produktinformations-skuffen. Bliver den ikke lukket
     først, ligger skuffen og dens mørke overlag bag modalen — og når kunden
     lukker modalen igen, står de midt i skuffen i stedet for på varen. */
  SizeFinder.prototype.closeDrawer = function () {
    var drawer = document.getElementById('Product-Information-Drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    var close = drawer.querySelector('.side-panel-close');
    if (close) close.click();
  };

  SizeFinder.prototype.open = function () {
    this.closeDrawer();
    this.state.reset();
    /* showModal flytter selv fokus til første fokuserbare element, så den
       skal køre FØR render. Ellers overskriver den vores fokus, og
       tastaturbrugeren lander på luk-knappen i stedet for første svar. */
    if (!this.dlg.open) this.dlg.showModal();
    this.render();
    this.lock(true);
    track('size_finder_opened', { product: this.data.productId });
  };

  SizeFinder.prototype.close = function () {
    if (this.dlg.open) this.dlg.close();
    this.lock(false);
  };

  /* Baggrunden må ikke kunne rulle bag modalen. <dialog> gør det ikke
     selv på iOS, så vi fastfryser body og lægger positionen tilbage. */
  SizeFinder.prototype.lock = function (on) {
    var b = document.body;
    if (on) {
      this._scrollY = window.scrollY;
      b.style.position = 'fixed';
      b.style.top = -this._scrollY + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.overflow = 'hidden';
    } else {
      b.style.position = ''; b.style.top = ''; b.style.left = '';
      b.style.right = ''; b.style.overflow = '';
      if (this._scrollY != null) window.scrollTo(0, this._scrollY);
    }
  };

  SizeFinder.prototype.prev = function () {
    if (this.state.result) { this.state.result = null; this.render(); return; }
    if (this.state.index > 0) { this.state.index--; this.render(); }
  };

  SizeFinder.prototype.answer = function (id, value) {
    this.state.answers[id] = value;
    if (this.state.index < this.state.total() - 1) {
      this.state.index++;
      this.render();
    } else {
      this.finish();
    }
  };

  SizeFinder.prototype.finish = function () {
    var d = this.data;
    this.state.result = window.SainteSizeEngine.recommend({
      guide: d.guide,
      offered: d.offered,
      available: d.available,
      answers: this.state.answers
    });
    track('size_finder_completed', { product: d.productId });
    track('size_finder_recommendation', {
      product: d.productId,
      status: this.state.result.status,
      recommended_size: this.state.result.size,
      confidence: this.state.result.confidence
    });
    this.render();
  };

  /* ---------------- rendering ---------------- */

  SizeFinder.prototype.render = function () {
    this.body.innerHTML = '';
    var wrap = el('div', 'sainte-sf__step');
    if (this.state.result) {
      this.renderResult(wrap);
      this.back.hidden = false;
      /* Skridttælleren giver ingen mening på resultatet, og en tom bjælke
         med ramme ville bare tilføje en streg uden indhold. */
      this.foot.textContent = '';
      this.foot.hidden = true;
    } else {
      this.renderStep(wrap);
      this.back.hidden = this.state.index === 0;
      this.foot.hidden = false;
      this.foot.textContent = L('step', 'Skridt %n%/%total%', { n: this.state.index + 1, total: this.state.total() });
    }
    this.body.appendChild(wrap);
    var first = wrap.querySelector('button, input');
    if (first) first.focus({ preventScroll: true });
    this.body.scrollTop = 0;
  };

  SizeFinder.prototype.renderStep = function (wrap) {
    var self = this, q = this.state.current();
    var gender = this.state.answers.gender || 'men';
    var heading = typeof q.heading === 'object' ? (q.heading[gender] || q.heading.men) : q.heading;

    wrap.appendChild(el('p', 'sainte-sf__eyebrow', esc(EYEBROW)));
    wrap.appendChild(el('h2', 'sainte-sf__heading', esc(heading)));

    if (q.type === 'choice') {
      var stack = el('div', 'sainte-sf__stack');
      q.options.forEach(function (o) {
        var b = el('button', 'sainte-sf__opt', esc(o.label));
        b.type = 'button';
        b.setAttribute('aria-pressed', self.state.answers[q.id] === o.value ? 'true' : 'false');
        b.addEventListener('click', function () { self.answer(q.id, o.value); });
        stack.appendChild(b);
      });
      wrap.appendChild(stack);

    } else if (q.type === 'sizes') {
      var chips = el('div', 'sainte-sf__chips');
      /* Kun de størrelser varen faktisk findes i. En 2XS der ikke er
         produceret, må ikke kunne vælges som "min normale størrelse". */
      this.data.offered.forEach(function (s) {
        var b = el('button', 'sainte-sf__chip', esc(s));
        b.type = 'button';
        b.setAttribute('aria-pressed', self.state.answers[q.id] === s ? 'true' : 'false');
        b.addEventListener('click', function () { self.answer(q.id, s); });
        chips.appendChild(b);
      });
      wrap.appendChild(chips);

    } else if (q.type === 'cards') {
      var cards = el('div', 'sainte-sf__cards');
      q.options.forEach(function (o) {
        var b = el('button', 'sainte-sf__card');
        b.type = 'button';
        var src = assetFor(self.data, gender, q.asset, o.value);
        if (src) {
          var img = new Image();
          img.src = src; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          b.appendChild(img);
        }
        b.appendChild(el('span', null, esc(o.label)));
        b.setAttribute('aria-pressed', self.state.answers[q.id] === o.value ? 'true' : 'false');
        b.setAttribute('aria-label', o.label);
        b.addEventListener('click', function () { self.answer(q.id, o.value); });
        cards.appendChild(b);
      });
      wrap.appendChild(cards);

    } else if (q.type === 'height') {
      var cfg = HEIGHT[gender] || HEIGHT.men;
      var box = el('div', 'sainte-sf__height');
      var val = el('p', 'sainte-sf__value');
      var input = document.createElement('input');
      input.type = 'range';
      input.className = 'sainte-sf__range';
      input.min = cfg.min; input.max = cfg.max; input.step = 1;
      input.value = this.state.answers.height || cfg.start;
      input.setAttribute('aria-label', L('aria_height', 'Din højde i centimeter'));
      var show = function () {
        val.textContent = input.value + ' cm';
        input.setAttribute('aria-valuetext', input.value + ' centimeter');
      };
      show();
      input.addEventListener('input', show);
      var cta = el('button', 'sainte-sf__cta', L('next', 'Næste'));
      cta.type = 'button';
      cta.addEventListener('click', function () { self.answer('height', parseInt(input.value, 10)); });
      box.appendChild(val); box.appendChild(input); box.appendChild(cta);
      wrap.appendChild(box);
    }
  };

  SizeFinder.prototype.renderResult = function (wrap) {
    var self = this, r = this.state.result;

    if (r.status === 'no_suitable_size' || r.status === 'guide_unusable') {
      wrap.appendChild(el('h2', 'sainte-sf__heading', L('fail_heading', 'Det var ikke muligt at anbefale en størrelse til dig.')));
      wrap.appendChild(el('p', 'sainte-sf__lead',
        L('fail_text', 'Det skyldes typisk, at denne vare ikke findes i en størrelse, som vi med tilstrækkelig sikkerhed kan anbefale ud fra dine oplysninger.')));
      var shop = el('button', 'sainte-sf__cta', L('continue', 'Fortsæt med at shoppe'));
      shop.type = 'button';
      shop.addEventListener('click', function () { self.close(); });
      wrap.appendChild(shop);
      wrap.appendChild(this.restartLink());
      return;
    }

    wrap.appendChild(el('p', 'sainte-sf__eyebrow', L('result', 'Dit resultat')));

    if (r.status === 'recommended_but_sold_out') {
      wrap.appendChild(el('h2', 'sainte-sf__heading', L('sold_out_heading', 'Vi anbefaler størrelse %size%, men den er desværre udsolgt.', { size: esc(r.size) })));
      if (r.alternativeSize) {
        wrap.appendChild(el('p', 'sainte-sf__note',
          L('sold_out_alt', 'Nærmeste størrelse på lager er %alt%. Den vil sidde anderledes end %size%, så vælg den kun hvis du er indforstået med det.', { alt: esc(r.alternativeSize), size: esc(r.size) })));
        wrap.appendChild(this.productCard(r.alternativeSize));
        wrap.appendChild(this.addButton(r.alternativeSize));
      }
      wrap.appendChild(this.restartLink());
      return;
    }

    /* Formuleringen er bevidst "vi anbefaler" og ikke "din perfekte
       størrelse". Vi kender kundens mål omtrentligt, ikke præcist. */
    wrap.appendChild(el('p', 'sainte-sf__result-label', L('we_recommend', 'Vi anbefaler størrelse')));
    wrap.appendChild(el('p', 'sainte-sf__size', esc(r.size)));
    if (r.reason) wrap.appendChild(el('p', 'sainte-sf__note', esc(r.reason)));
    wrap.appendChild(this.productCard(r.size));
    wrap.appendChild(this.addButton(r.size));
    wrap.appendChild(this.restartLink());
  };

  /* Viser hvad kunden er ved at købe — billede, navn og prisen for netop
     den anbefalede størrelse. Uden det står der bare et bogstav, og man
     skal lukke modalen for at se hvad man har valgt. */
  SizeFinder.prototype.productCard = function (size) {
    var p = this.data.product || {};
    var v = (this.data.variants || {})[size] || {};
    var card = el('div', 'sainte-sf__product');
    if (p.image) {
      var img = new Image();
      img.src = p.image; img.alt = ''; img.className = 'sainte-sf__product-img';
      img.loading = 'lazy'; img.decoding = 'async';
      card.appendChild(img);
    }
    var meta = el('div', 'sainte-sf__product-meta');
    meta.appendChild(el('span', 'sainte-sf__product-title', esc(p.title || '')));
    var line = [];
    if (v.price) line.push(v.price);
    line.push(L('size_n', 'Størrelse %size%', { size: size }));
    meta.appendChild(el('span', 'sainte-sf__product-sub', esc(line.join(' · '))));
    card.appendChild(meta);
    return card;
  };

  SizeFinder.prototype.addButton = function (size) {
    var self = this;
    var b = el('button', 'sainte-sf__cta', L('add_to_cart', 'Tilføj til kurv'));
    b.type = 'button';
    b.addEventListener('click', function () {
      if (b.dataset.busy) return;
      b.dataset.busy = '1';
      b.textContent = L('adding', 'Tilføjer …');
      self.addToCart(size, b);
    });
    return b;
  };

  /*
    Vi lægger IKKE i kurven med vores eget fetch. I stedet sættes størrelsen
    i temaets egen variantvælger, og temaets egen købsknap trykkes. Så kører
    kurv-skuffen, eventuelle upsells og temaets sporing præcis som ved et
    normalt køb — i stedet for at vi bygger en parallel købsvej der skal
    holdes ved lige.

    Temaet henter sektionen igen når varianten skifter, så vi venter på at
    formularens id rent faktisk er den ønskede, før der trykkes.
  */
  /* Produktsiden har flere kurv-formularer (bl.a. en til afdragsbetaling)
     og flere købsknapper (sticky-bar, quick view). Vi må derfor ikke bare
     tage den første, der findes — vi går efter dén sektion, som selve
     variantvælgeren hører til. */
  SizeFinder.prototype.mainForm = function () {
    var picker = document.querySelector('variant-radios, variant-selects');
    var section = picker && picker.dataset.section;
    return (section && document.getElementById('product-form-' + section))
      || document.querySelector('form[action*="/cart/add"]');
  };

  function visible(elem) {
    return !!(elem && elem.offsetParent !== null);
  }

  SizeFinder.prototype.addToCart = function (size, btn) {
    var self = this;
    var target = ((this.data.variants || {})[size] || {}).id;
    var info = (this.data.variants || {})[size] || {};

    track('selected_size_after_recommendation', {
      product: this.data.productId,
      recommended_size: this.state.result ? this.state.result.size : null,
      selected_size: size
    });

    /* Luk FØR der lægges i kurven. Ellers åbner temaets kurv-skuffe bag en
       modal, der stadig ligger over den, og kunden tror intet skete. */
    this.close();
    this.selectVariant(size);

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      document.removeEventListener('product:variant-change', onChange);

      track('add_to_cart_after_size_finder', {
        product: self.data.productId,
        recommended_size: self.state.result ? self.state.result.size : null,
        selected_size: size
      });

      var form = self.mainForm();
      var candidates = [].slice.call(document.querySelectorAll('.single-add-to-cart-button'));
      var atc = (form && form.querySelector('.single-add-to-cart-button'))
        || candidates.filter(visible)[0]
        || candidates[0]
        || (form && form.querySelector('[type="submit"]'));
      if (!atc) return;

      /* Størrelsesporten lukker knappen, indtil kunden selv har rørt
         størrelsesrækken. Har vi valgt en variant der er på lager, er den
         port opfyldt, også selv om temaet ikke nåede at åbne den endnu. */
      if (info.available !== false) atc.removeAttribute('disabled');
      atc.click();
    }

    function onChange() { setTimeout(finish, 60); }
    document.addEventListener('product:variant-change', onChange);

    /* Var størrelsen allerede valgt, kommer der ingen ændring — så tjekker
       vi selv, om formularen allerede peger på den rigtige variant. */
    var tries = 0;
    (function poll() {
      if (done) return;
      var form = self.mainForm();
      var input = form && form.querySelector('input[name="id"]');
      if (!target || (input && String(input.value) === String(target))) { finish(); return; }
      if (++tries > 40) { finish(); return; }   // ~4 sekunder, så prøver vi alligevel
      setTimeout(poll, 100);
    })();
  };

  SizeFinder.prototype.restartLink = function () {
    var self = this;
    var a = el('button', 'sainte-sf__link', L('restart', 'Start forfra'));
    a.type = 'button';
    a.addEventListener('click', function () { self.state.reset(); self.render(); });
    return a;
  };

  SizeFinder.prototype.chooseButton = function (size, label) {
    var self = this;
    var b = el('button', 'sainte-sf__cta', esc(label));
    b.type = 'button';
    b.addEventListener('click', function () {
      self.selectVariant(size);
      track('selected_size_after_recommendation', {
        product: self.data.productId,
        recommended_size: self.state.result ? self.state.result.size : null,
        selected_size: size
      });
      self.close();
    });
    return b;
  };

  /* Sætter størrelsen i temaets egen variantvælger. Vi klikker på
     label'en frem for at sætte input.checked, fordi temaets
     VariantSelects lytter på change fra .variations — og fordi
     sainte-size-gate åbner købsknappen på netop den hændelse. */
  SizeFinder.prototype.selectVariant = function (size) {
    var pickers = document.querySelectorAll('variant-radios, variant-selects');
    for (var i = 0; i < pickers.length; i++) {
      var wrap = pickers[i].querySelector('.variations');
      if (!wrap) continue;
      var field = wrap.querySelector('fieldset[data-handle="size"]') || wrap.querySelector('fieldset');
      if (!field) continue;
      var inputs = field.querySelectorAll('input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        if (String(inputs[j].value).toUpperCase() !== String(size).toUpperCase()) continue;
        var label = field.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inputs[j].id) : inputs[j].id) + '"]');
        if (label) { label.click(); } else { inputs[j].click(); }
        return true;
      }
    }
    return false;
  };

  /* ------------------------------------------------------------------ */

  SF.init = function () {
    var data = window.SainteSizeFinderData;
    var root = document.getElementById('sainte-size-finder');
    if (!data || !root || !window.SainteSizeEngine) return;
    if (!data.offered || !data.offered.length) return;

    /* Liquid leverer guiden rå — præcis de kolonner og rækker kunden ser
       i størrelsesguiden. Tolkningen sker i motoren, så der kun findes
       én forståelse af tabellen. */
    var parsed = window.SainteSizeEngine.parseGuide(data.guide);
    if (!parsed) return;
    data.guide = parsed;

    /* Størrelser der står i guiden, men ikke findes som variant, må ikke
       kunne vælges — og omvendt skal en variant uden mål ikke kunne blive
       anbefalet. Vi skærer til fællesmængden. */
    var inGuide = {};
    parsed.sizes.forEach(function (s) { inGuide[s.size] = true; });
    data.offered = data.offered.filter(function (s) { return inGuide[s]; });
    data.available = (data.available || []).filter(function (s) { return inGuide[s]; });
    if (!data.offered.length) return;

    var finder = new SizeFinder(root, data);
    SF.instance = finder;

    /* Først nu ved vi, at der er tal nok til en anbefaling. Knappen
       afsløres derfor herfra og ikke i Liquid. */
    document.querySelectorAll('[data-sainte-size-finder]').forEach(function (btn) {
      btn.hidden = false;
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-sainte-size-finder]') : null;
      if (!t) return;
      e.preventDefault();
      finder.open();
    });

    /* Køb efter en anbefaling — så vi senere kan holde anbefaling op mod
       hvad der faktisk blev lagt i kurven. */
    document.addEventListener('submit', function (e) {
      if (!finder.state.result || !e.target.matches('form[action*="/cart/add"]')) return;
      track('add_to_cart_after_size_finder', {
        product: data.productId,
        recommended_size: finder.state.result.size
      });
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', SF.init);
  } else {
    SF.init();
  }

  window.SainteSizeFinder = SF;
})();
